import { Alert, Breadcrumb, Col, EventHandler, Row } from "client/CommonComponents";
import CreateNewRequisition from "../CreateNewRequisition";
import MyCart from "../MyCart";
import "./Asset.scss";
import CancelConfirmationPopup from "client/CommonComponents/DialogBox/CancelConfirmationPopup";
import { CONSTANTS } from "client/utils/constants";

interface IProps {
    showMyCartTransfer?: any
    setShowMyCartTransfer?: any
    breadcrumlist?: any
    handleClickBack?: any,
    itemDetailComponent?: any,
    mobile: boolean,
    mycartButton: any,
    showCart: boolean,
    handleClickAddCart?: any,
    dismissSuccessAlert?: any,
    successAlert: boolean,
    setItemDetailComponent?: any,
    setShowCart?: any,
    setSuccessAlert?: any,
    showCreateRequisition?: boolean,
    setShowCreateRequisition?: any,
    setShowCartClicked?: any,
    orderDetails?: any,
    Popupcontent?: any,
    hideDialog?: any,
    errorAlert?: any,
    dismissErrorAlert?: any,
    setErrorAlert?: any,
    assets?: any,
    setTotalPenaltyFee?: any,
    totalPenaltyFee?: any,
    isAFERequestType?: any
}
const Asset = (props: IProps) => {
    const setTotalPenaltyFee = props?.setTotalPenaltyFee;
    const totalPenaltyFee = props?.totalPenaltyFee
    return (<>
        <div className='breadCrumbBlock'>
            {/* {
                props.mobile ?
                    <div className='backIcon' onClick={props.handleClickBack}>
                        <img src={arrowIcon} alt='back Btn' />
                    </div> :  */}
                    <EventHandler onEvent={props.handleClickBack} data-attribute="Asset_Default_EventHandler">
                        <div className='backButton mb-sm-2 mb-3'>
                            <span className="fa fa-chevron-left"></span>
                            Back
                        </div>
                    </EventHandler>
            {/* } */}
            <div className='breadcrumbList'>
                <Breadcrumb items={props.breadcrumlist} maxDisplayedItems="5"  data-attribute="Asset_Default_Breadcrumb" />
            </div>
            {
                props.mobile && !props.showCart ?
                    <EventHandler onEvent={props.mycartButton} data-attribute="Asset_Default_EventHandler_2">
                        <div className='mycartButton'>
                            My Cart ({props.assets?.length || 0 || 0})
                        </div>
                    </EventHandler> : null
            }
        </div>
        <Row>
            <Col xs={12} md={12} lg={props.isAFERequestType() ? 12 : 8} className={`createRequisition ${props.showCreateRequisition ? '' : 'hideCreate'}`}>
                <CreateNewRequisition
                    setShowCart={props.setShowCart}
                    setShowCartClicked={props.setShowCartClicked}
                    mobile={props.mobile}
                    setShowCreateRequisition={props.setShowCreateRequisition}
                    setSuccessAlert={props.setSuccessAlert}
                    setErrorAlert={props.setErrorAlert}
                    setTotalPenaltyFee = {setTotalPenaltyFee}
                    totalPenaltyFee ={totalPenaltyFee}
                    showCart = {props?.showCart}
                />
            </Col>
            {
                props.showCart && props.successAlert &&
                <Alert
                    className="alert-message successAlert"
                    showAlert={props.successAlert}
                    dismissAlert={props.dismissSuccessAlert}
                    type="success"
                    text="Successfully added to the cart"
                 data-attribute="Asset_Default_Alerts" />
            }
            {
                props.showCart && props.errorAlert &&
                <Alert
                    className="alert-message errorAlert"
                    showAlert={props.errorAlert}
                    dismissAlert={props.dismissErrorAlert}
                    type="error"
                    text="Asset is added to cart already..!!"
                 data-attribute="Asset_Default_Alerts_2" />
            }
            {
                props.showCart ?
                    <Col xs={12} md={12} lg={4} className='myCartBlock asset-flow mt-lg-0 mt-sm-3'>
                        <MyCart mobile={props.mobile} setTotalPenaltyFee = {setTotalPenaltyFee} totalPenaltyFee = {totalPenaltyFee}/>
                    </Col> : null
            }
        </Row>
        {props?.Popupcontent?.isDialogVisible ? <CancelConfirmationPopup
            hideDialog={!props.Popupcontent.isDialogVisible}
            onDismiss={props.hideDialog}
            Popupcontent={props.Popupcontent}
            popupOutlinebtnOnclick={() => props.Popupcontent.popupConfirmationOutlinebtnOnclick()}
            popupPrimarybtnOnclick={() => props.Popupcontent.popupConfirmationPrimarybtnOnclick()}
            popupAdditionalBtnOnCLick = {() => props.Popupcontent.popupConfirmatioAdditionalbtnOnclick()}
        /> : ""}
    </>)
}

export default Asset;
